import type { User } from '@/types/Api';
import { getApiBaseUrl } from '@/lib/apiUrl';

interface AdminRoleResponse {
  role: string;
}
export interface UserDataPayload extends User, AdminRoleResponse {}

export const userService = {
  async getUserByAuthUserId(authUserId: string, token: string): Promise<User | undefined> {
    try {
      const res = await fetch(`${getApiBaseUrl()}/users/authUserId/${authUserId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });
      if (!res.ok) {
        throw new Error(`Error: ${res.statusText}`);
      }

      return await res.json();
    } catch (e) {
      console.error('Error fetching user by ID', e);
    }
  },
  async getAdminRoleById(id: string, token: string): Promise<{ role: string }> {
    try {
      const res = await fetch(`${getApiBaseUrl()}/users/adminRoles/${id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });
      if (!res.ok) {
        throw new Error(`Error: ${res.statusText}`);
      }

      return await res.json();
    } catch (e) {
      console.error('Error fetching user by ID', e);
      throw e;
    }
  },
};
